export default __webpack_public_path__ + "static/media/Linux-Avatar.b91734bd.svg";